// extracted by mini-css-extract-plugin
export default {"wrapper":"statistic_wrapper__wDkPW","container":"statistic_container__GleLx","top":"statistic_top__DS0UZ"};